<template>
  <div>
    <div v-if="templateLoading" class="pagestopper" onclick="StopProp()"></div>
    <nav class="navbar navbar-expand-lg navbar-light navigation">
      <a>
        <h4 class="mb-0 mr-4">
          <!-- <input type="text" v-if="editTitle" :value="$store.state.project.name" @blur="projectName = $event.target.value; editTitle = false; ProjectRename(projectName);" @keyup.enter="projectName = $event.target.value; editTitle = false; ProjectRename(projectName);" v-focus="" /> -->
          <span class="uk-text-bold notTooBig">{{ $store.state.project.name }}</span>
        </h4>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        onclick="ToggleNavMenu(event)" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              File
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li v-if='!sample' class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Purchase
                  History</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a v-if="$store.state.project.purchase_history.length === 0">No Purchases</a>
                  <a class="dropdown-item dropdown" v-for="value in $store.state.project.purchase_history"
                    :key="value.product_title">{{ value.product_title }} : <span v-if="value.complete"
                      style="color:green">Done</span><span v-if="!value.complete"
                      style="color:orange">Working</span></a>
                </div>
              </li>
              <li v-if="auth && !sample">
                <a class="dropdown-item" onclick="ShareReport('toggle', event)">
                  <span v-if="shared == false" style="cursor:pointer">Share Report</span>
                  <span v-if="shared == true" style="cursor:pointer">Unshare Report</span>
                </a>
              </li>
              <li v-if="auth && !sample">
                <a class="dropdown-item" v-if="shared == true" onclick="CopyShareURL()" style="cursor:pointer">
                  <span class="optionLabel">click to copy Shared URL</span>
                </a>
              </li>
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <li v-if="auth"><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'new-project')">New
                  Project</a></li>

              <li v-if="auth == true"><a class="dropdown-item" href="#"
                  onclick="store.dispatch('openProjects', {functions:'open'})">Open Project</a></li>
              <li v-if="auth && !sample"><a class="dropdown-item" href="#" onclick="Save_project()">Save Project</a>
              </li>
              <li v-if="auth && !sample"><a class="dropdown-item" href="#"
                  onclick="app.confirm.message = 'Are you sure you want to reset this project';app.confirm.params=false;app.confirm.funct=Reset_project; OpenModal('confirmModal');">Reset
                  Project</a></li>
              <li v-if="auth == false"><a class="dropdown-item" href="#" onclick="OpenModal('loginModal')">Open</a></li>
              <!-- <li v-if="!auth"><a class="dropdown-item" href="#" onclick="OpenModal('loginModal')">Save</a></li> -->
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <li class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Import</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <div class="warningNote">Warning! This is a beta feature and is prone to breakage</div>
                  <a class="dropdown-item" onclick="getCSV(importDataByKeyword, 'analyzeKeywords');">New Columns</a>
                  <a class="dropdown-item" onclick="getCSV(importDataAndKeyword, 'analyzeKeywords');">New Keywords and
                    Columns</a>
                  <a class="dropdown-item" onclick="getCSV(importjustKeywords, 'analyzeKeywords');">Just New
                    Keywords</a>
                  <a class="dropdown-item" onclick="getCSV(importDeepData, 'analyzeKeywords');">Keywords Sub List
                    Report</a>
                </div>
              </li>
              <li class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Export</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" onclick="dataExporting('csv');">CSV</a>
                  <a class="dropdown-item" onclick="dataExporting('json');">json</a>
                  <a class="dropdown-item" onclick="dataExporting('xlsx');">xlsx</a>
                </div>
              </li>
              <!--<li v-if="auth && !sample">
                <a class="dropdown-item" onclick="OpenSaveToDrive()">
                  <span style="cursor:pointer">Save To Google Drive</span>
                </a>
              </li>-->
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <!--
                                <li><a class="dropdown-item" href="#" v-on:click="FullCardToggle('settings', true); cards.settings.states.project.active = true">Duplicate Project</a></li>
                                <li class="dropdown-submenu">
                                    <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#"> Add Keywords to Another Project</a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <a class="dropdown-item"  v-on:click="projectListMenu.state = 'selected';projectListMenu.criteria = 'selected'" data-toggle="modal" data-target="#projectSelect;" >Selected Keywords</a>
                                            <a class="dropdown-item" v-on:click="projectListMenu.state = 'selected';projectListMenu.criteria = 'all'" data-toggle="modal" data-target="projectSelect;">All Keywords</a>
                                            <a class="dropdown-item" onclick="DuplicateKeywords('all', true);">Selected to New Project</a>
                                        </div>
                                    </a>
                                </li>
                                -->
              <!-- <li v-if="auth"><a class="dropdown-item" href="#" onclick="app.confirm.message = 'Are you sure you want to delete this project';app.confirm.params=false;app.confirm.funct=Reset_project; OpenModal('confirmModal');">Delete Project</a></li> -->
              <!-- <li v-if="auth"><a class="dropdown-item" href="#" onclick="OpenModal('loginModal')">Duplicate Project</a></li> -->
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              Edit
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" href="#"
                  onclick="store.commit('showSide', 'score-column-create');ScrollInComp('createScore')">Custom Score
                  Column or Bucket Column</a></li>
              <!--<li><a class="dropdown-item" href="#"
                  onclick="store.commit('showSide', 'score-column-create');ScrollInComp('createBucket')">Custom Bucket
                  Column</a></li>-->
              <!--<li><a class="dropdown-item" href="#"
                  onclick="store.commit('showSide', 'score-column-create');ScrollInComp('createAgg')">Custom Statistic
                  Column</a></li> -->
              <li><a class="dropdown-item" href="#" onclick="newColumnBackup({type:'note'})">Notes Column</a></li>
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <!-- <li><a class="dropdown-item" href="#" onclick="getCSV(importDataByKeyword, 'analyzeKeywords')">Import Columns</a></li> -->
              <!-- <li><a class="dropdown-item" href="#" onclick="app.confirm.message = 'Are you sure you want to remove selected keywords';app.confirm.params=false;app.confirm.funct=DeleteKeywords; OpenModal('confirmModal')">Remove Selected Keywords</a></li> -->
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('showSide', 'settings-control')">User
                  Settings</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              View
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Keyword
                  Filters</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <filter-controls></filter-controls>
                </div>
              </li>
              <li class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Sort
                  Keyword Rows</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <column-sorter></column-sorter>
                </div>
              </li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('GroupSelectedRows')">Create Group of Selected
                  Keyword Rows</a></li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('showSide', 'group-by-filter-create')">Create
                  Group by Formula</a></li>
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <!-- <li><a class="dropdown-item" href="#" onclick="FreezeRows()">Selected Rows Always Visible</a></li>
                            <li><a class="dropdown-item" href="#" onclick="UnFreezeRows()">Selected Rows Normal</a></li> -->
              <li class="dropdown-submenu">
                <a class="dropdown-item dropdown-toggle dropbtntog" onclick="ToggleDropdown(event)" href="#">Keyword
                  Column Visibility</a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <column-visibility></column-visibility>
                </div>
              </li>
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <li><a class="dropdown-item" href="#" onclick="openFullscreen();">Full Screen</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              Format
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <!--<li><a class="dropdown-item" href="#" v-on:click="FullCardToggle('formatting', true, ['conditional']);">Conditional Formatting</a></li>-->
              <!--<li><a class="dropdown-item" href="#" v-on:click="FullCardToggle('createCard', true, ['chart']);">Create Chart</a></li>-->
              <li><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'pivot-create')">Create Pivot
                  Table</a></li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'pivot-create-urls')">Create Url
                  Pivot Table</a></li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('GenerateNote', {newPage:true})">Create Note
                  Page</a></li>
              <li>
                <div class="dropdown-divider"></div>
              </li>
              <!--<li><a class="dropdown-item" href="#" v-on:click="cards.templatesCard.state = 'browse'; FullCardToggle('templatesCard');">Browse Templates</a></li>-->
              <li><a class="dropdown-item" href="#" onclick="store.commit('ChangeStripe')">Toggle Stripped Rows</a></li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'template-market')">Browse
                  Templates</a></li>

            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              Data
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" href="#">Keywords ({{ rowCount }})</a></li>
              <li><a class="dropdown-item" href="#" onclick="load_product_domains(true)">Domains <span
                    v-if="domainCount > 0">({{ domainCount }})</span></a></li>
              <li><a class="dropdown-item" href="#" onclick="load_product_urls(true)">URLS <span v-if="urlCount > 0">({{
                urlCount }})</span></a></li>
              <!--<li><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'market-place')">Browse
                  Reports</a></li>-->
            </ul>
          </li>


          <li class="nav-item dropdown">
            <a class="nav-link dropbtntog" href="#" role="button" data-toggle="dropdown" onclick="ToggleDropdown(event)"
              aria-haspopup="true" aria-expanded="false">
              Dashboards
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" href="#" onclick="store.commit('newPage', {stockTab:'Groups Panel'})">Show
                  All Keyword Groups</a></li>
              <!--<li><a class="dropdown-item" href="#" onclick="store.commit('newPage', {stockTab:'Notes'})">Notes Panel</a></li>-->
              <!--<li><a class="dropdown-item" href="#" v-on:click="CreateStockOvertab('chart')" disabled>Chart Panel</a></li>-->
              <li><a class="dropdown-item" href="#"
                  onclick="store.commit('newPage', {stockTab:'Pivot Table Panel'})">Show All Pivot Tables</a></li>
              <!--<li><a class="dropdown-item" href="#" v-on:click="CreateStockOvertab('Data History')" disabled>Purchase History</a></li>
                            <li><a class="dropdown-item" href="#" onclick="OpenModal('QuickActionModal')">Open Quick Action Panel</a></li> -->
              <li><a class="dropdown-item" href="#" onclick="load_product_urls(true)">Show URLS</a></li>
              <li><a class="dropdown-item" href="#" onclick="load_product_domains(true)">Show Domains</a></li>
              <li><a class="dropdown-item" href="#" onclick="store.commit('showModal', 'sheet-keywords');">Sheet
                  Keywords</a></li>

            </ul>
          </li>
          <li class="nav-item" onclick="Save_project()" style="margin-right:10px;cursor: pointer;"
            v-if="auth && !sample"><a v-if="saved" class="nav-link"
              style="font-size:.75em; color:red; margin-top: 0.35em;">Unsaved</a> <a v-if="!saved" class="nav-link"
              style="font-size:.75em; color:gray; margin-top: 0.35em;">Saved</a></li>
        </ul>
        <ul class="navbar-nav subnaver">
          <!--<li><a class="navbar-brand" href="/" style="color:white"></a></li>-->

          <!--<li v-if="auth" class="nav-item">
              <a class="nav-link btn btn-sm titleButton expandButton" onclick="alert('coming soon')">
                  <i class="fas fa-heart"></i>
                  <span>Favorite</span>
              </a>
          </li> -->
          <li v-if="auth && !sample" class="nav-item">
            <a class="nav-link btn-sm titleButton expandButton" onclick="Save_project()">
              <i class="fas fa-save"></i>
              <span>Save</span>
            </a>
          </li>
          <li v-if="auth && !sample" class="nav-item">
            <a class="nav-link btn btn-sm titleButton shareButton expandButton"
              v-bind:class="{ 'sharedBack': shared == false }" onclick="ShareReport('toggle', event)">
              <i class="fas fa-share-alt"></i>
              <span v-if="shared == false" class="">Click to Share</span>
              <span v-if="shared == true" class="">Click to Unshare</span>
            </a>
          </li>
          <!--<li v-if="auth && !sample" class="nav-item">
            <a class="nav-link btn-sm titleButton expandButton" onclick="OpenSaveToDrive()">
              <i class="tab-button download-google"></i>
              <span>Save To Drive</span>
            </a>
          </li>-->
          <li class="nav-item">
            <a class="nav-link btn btn-sm titleButton expandButton" onclick="dataExporting('xlsx');">
              <i class="fas fa-download"></i>
              <span>Download</span>
            </a>
          </li>
          <li v-if="auth" class="nav-item">
            <a class="nav-link btn btn-sm titleButton expandButton"
              onclick="store.commit('showSide', 'settings-control')">
              <i class="fas fa-cog"></i>
              <span>Settings</span>
            </a>
          </li>
          <li v-if="!auth" class="nav-item"><a class="nav-link" href="#" onclick="window.location = '/login'">Login</a>
          </li>
        </ul>
      </div>
    </nav>

    <div id="subnav" class="wide" :class="{ superSmaller: activePage.code != 'keywords' }">

      <div id="page-navigation" class="wide d-flex newTabWrapper"
        :class="{ superSmaller: activePage.code != 'keywords' }">
        <div class="nav nav-tabs">
          <div class="sub-nav-icon btn-effects"
            style="border-bottom:2px solid var(--blue);display: flex; align-items:center; min-height:100%; height:100%">
            <span class="dropbtntog" onclick="ToggleDropdown(event)" data-toggle="dropdown"><i
                class="fas fa-list fa-lg"></i></span>
            <div class="dropdown-menu pagesDropDown" aria-labelledby="dropdownMenuButton">
              <div class="uk-flex uk-flex-column">
                <div v-for="(page, index) in $store.state.pages" :key=index v-bind:value="index"
                  v-on:click="$store.commit('changePage', index)" class="pop-nav-list btn-effects"
                  style="padding-left:0px">
                  <span class="d-flex">
                    <span class="squareSize">
                      <span v-bind:class="{ located: page.active }" class="marker">
                        <i class="fas fa-map-marker-alt"></i>
                      </span>
                    </span>
                    <span class="pop-nav-text">{{ page.title }}</span>
                  </span>
                </div>
                <!--<button v-for="(tab, index) in $store.state.pages" v-bind:value="index" v-on:click="$store.commit('changePage', index)" class="uk-button uk-button-default uk-text-left" style="padding-left:0px"><span class="uk-flex"><span class="squareSize"><span v-if="tab.active" uk-icon="location"></span></span>{{tab.title}}</span></button> -->
              </div>
            </div>
          </div>
          <div v-for="(page, index) in $store.state.pages" :key="index">
            <div else class="nav-item dropdown"
              v-bind:class="{ active: page.active, loadingPages: !finishedLoadingPages }"
              v-on:click="$store.commit('changePage', index)">
              <div style="margin-right:4px;">{{ page.title }}</div>
              <span v-if="page.active" style="margin-left:7px" class="dropbtntog" data-toggle="dropdown"
                onclick="ToggleDropdown(event)"><i class="fas fa-chevron-down" style="margin-top:1px"></i></span>
              <div v-if="page.active" class="dropdown-menu" aria-labelledby="dropdownMenuButton"
                style="padding-bottom:0px;">
                <div class="d-flex flex-column">
                  <input type="text" v-model="page.title" style="width:100%"
                    v-on:change="$store.commit('RenamePage', { newtitle: page.title, tabToRename: index })">
                  <button v-if="page.code != 'keywords'"
                    v-on:click="$store.commit('DuplicatePages', index)">Duplicate</button>
                  <button v-if="page.code != 'keywords'"
                    v-on:click="confirm.message = 'Are you sure you want to delete this page?'; confirm.funct = DeletePageWrap; confirm.params = index; PopConfirmUp();">Delete</button>
                </div>
              </div>
            </div>
          </div>
          <div class="sub-nav-icon btn-effects" v-on:click="$store.commit('newPage')"
            style="border-bottom:2px solid var(--blue);display: flex; align-items:center; height:100%"><i
              class="fas fa-plus fa-lg"></i></div>
        </div>
        <div class="spacerOfNav" style="flex-grow:1;border-top:1px solid #dee2e6;border-bottom:1px solid #dee2e6">
          <div style="border-bottom:2px solid var(--blue);height:100%;width:100%">
            <button type="button" class="btn btn-outline-primary buttonOfTemplate"
              onclick="store.commit('showModal', 'template-market')">Browse Templates</button>
          </div>
        </div>
        <div id="table-toolbar" class="btn-toolbar" role="toolbar" style="justify-self:flex-end;margin-bottom:2px"
          v-if="activePage.code == 'keywords'">
          <div class="btn-group" role="group" aria-label="First group">
            <button class="btn btn-secondary filterButton dropbtntog" data-toggle="dropdown"
              onclick="ToggleDropdown(event)"><i class="fas fa-filter"></i></button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <filter-controls></filter-controls>
            </div>
            <textarea id="posFilter" placeholder="Positive Filter" class="newFilter"
              v-debounce:100ms="setFilter"></textarea>
            <textarea id="negFilter" placeholder="Negative Filter" class="newFilter"
              v-debounce:100ms="setFilter"></textarea>
          </div>

          <div class="btn-group" role="group" aria-label="Second group">
            <button class="btn btn-secondary filterButton dropbtntog" data-toggle="dropdown"
              onclick="ToggleDropdown(event)" v-on:click="currentDropComponent = 'column-sorter'"><i
                class="fas fa-sort-amount-down"></i></button>
            <div class="dropdown-menu">
              <component v-bind:is="currentDropComponent"></component>
            </div>
            <button class="btn btn-secondary filterButton dropbtntog" data-toggle="dropdown"
              onclick="ToggleDropdown(event)" aria-haspopup="true" aria-expanded="false"
              v-on:click="currentDropComponent = 'column-visibility'"><i class="far fa-eye"></i><i
                class="far fa-eye-slash" style="display:none"></i></button>
            <div class="dropdown-menu">
              <component v-bind:is="currentDropComponent"></component>
            </div>
            <!--<button class="btn btn-secondary filterButton" style="position:relative"
              onclick="store.commit('showModal', 'market-place')"><i class="fas fa-shopping-cart"></i><span
                v-if="cartCount > 0" class="numberIcon">{{ cartCount }}</span></button>-->
            <button class="btn btn-secondary filterButton" onclick="store.commit('showModal', 'template-market')"><i
                class="far fa-calendar"></i></button>
            <button class="btn btn-secondary filterButton" onclick="store.commit('showModal', 'pivot-create')"><i
                class="fas fa-table"></i></button>
            <button class="btn btn-secondary filterButton" onclick="store.commit('showSide', 'score-column-create')"><i
                class="fas fa-plus-square" style="padding-top:2px;"></i></button>
          </div>
        </div>
      </div>



      <!--<div class="flex">
                <div class="glassCard HeadCard goneOnSmall" style="height:fit-content">
                    <select class="uk-select keywordgentop" v-model="HeadKeywords">
                        <option value="" disabled>Add Keywords</option>
                        <option v-for="gen in keywordGenerators" :key="gen.name" :value="gen.code">{{gen.name}}</option>
                        <option value="Browse Options" disabled>Browse Options</option>
                    </select>
                    <input class="element-button" onclick="store.commit('showModal', 'sheet-keywords');" type="button" value="Sheet Keywords" v-bind:class="{hide:HeadKeywords != 'sheetkeyskeywordgen'}">
                    <button v-if="HeadKeywords != 'sheetkeyskeywordgen'" class="element-button " uk-toggle="target: #keywordGenModal;" :disabled="HeadKeywords == 'Browse Options'">Add</button>
                </div>

                <div class="glassCard HeadCard goneOnLarge" style="height:fit-content">
                    <select v-model="HeadColumn" class="" style="border:1px solid green">
                        <option value="start" disabled>Add Columns</option>
                        <option v-for="report in reports" :value="report" :key="report.shortTitle">{{report.shortTitle}}</option>
                        <option value="Browse Options">Browse Options</option>
                    </select>
                    <button class="" v-on:click="SetPurchase('HeadColumn')" :disabled="HeadColumn == 'Browse Options' || sample">Add</button>
                     v-on:click="SetCart('confirmPrice','all', HeadColumn, true);" -->
      <!--</div>

                <div class="glassCard HeadCard goneOnMedium" style="height:fit-content">
                    <select v-model="HeadTemplate" name="" class="">
                        <option value="" disabled>Add a Template</option>
                        <option v-for="template in templates" :value="template.name" :key="template.name" :disabled="template.dis == true">{{template.name}}</option>
                        <option value="Browse Templates" disabled>Browse Templates</option>
                    </select>
                    <button class="" v-on:click="AddTemplate(HeadTemplate, true)" :disabled="HeadTemplate == 'Browse Templates'">Add</button>
                </div>

  
            </div>-->

    </div>



    <div id="main-container" :class="{ superSmaller: activePage.code != 'keywords' }">
      <div id="page-container">

        <div v-if="!orderDone" id="loader-outer" class="loading-bar glassCard max-loader">
          <span class="minimize" onclick="minLoader()" style="cursor:pointer">-</span>
          <div style="text-align:center">
            <span class="loadText" style="font-style:italic;font-weight:bold;text-align:center;">This order is
              processing. <span v-if="minutes != undefined && minutes > 0"> Estimated completion time is {{ minutes }}
                Minutes.</span><span v-else>Your project should be completed soon</span></span>
          </div>
          <div style="display:flex; flex-direction:column; align-items:center; justify-content:center">
            <div class="loading">
              <div class="loading-dot"></div>
              <div class="loading-dot"></div>
              <div class="loading-dot"></div>
              <div class="loading-dot"></div>
            </div>
            <div
              style="font-style:italic;font-weight:bold;font-size:10px;text-align:center; position: relative;bottom: -4px;display:flex;flex-direction:column">
              Working On Order <span style="float:clear; font-size:.5rem" v-if="minutes != undefined && minutes > 0">({{
                minutes }} minutes)</span></div>
          </div>
        </div>
        <div v-if="templateLoading" id="loader-outerer" class="loading-bar glassCard">
          <div class="loading">
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
            <div class="loading-dot"></div>
          </div>
          <div
            style="font-style:italic;font-weight:bold;font-size:10px;text-align:center; position: relative;bottom: -4px;">
            Creating Template, Please wait</div>
        </div>
        <div id="page" v-bind:class="{ back: sideDisplay }">

          <div id="table-container" v-bind:class="{ back: activePage.code != 'keywords' }">

            <div id="keyword-table"></div>
            <div v-show="activePage.code == 'keywords'" id="table-footer" class="wide d-flex newTabWrapper">
              <div class="tokenCostBox d-flex"
                style="margin-top: 0px; margin-right:0px; align-items:center; padding:3px; padding-right:0px">
                <div style="font-size: .7rem;text-align:center">Results</div>
                <div style="font-size: .7rem;text-align:center">{{ filterCount }} <span
                    v-if="filterCount != rowCount">({{
                      rowCount }})</span></div>
              </div>


              <div class="tabulator"
                style="background: transparent; align-self: flex-end; display:flex; justify-content:center;height:100%;box-sizing:border-box">
                <div id="pageControls" class="tabulator-footer"
                  style="background: transparent; display:flex; align-items:center">
                </div>
              </div>
            </div>
          </div>
          <div id="other-container" v-bind:class="{ back: activePage.code == 'keywords' }">
            <page-component v-for="page in pages" :key="page" :props="page">

            </page-component>
            <!-- <KeepAlive :max="10"> 
                            <page-component :props="activePage"></page-component>
                          </KeepAlive> -->
          </div>
        </div>

        <div id="returnBar" v-on:click="$store.commit('toggleSide')" v-bind:class="{ revealed: sideDisplay }">
          <h4>Back To {{ activePage.title }}</h4>
        </div>
        <div id="gutteredge" v-bind:class="{ revealed: sideDisplay }">
          <div v-on:mousedown="Resizer($event)"></div>
        </div>
        <div id="sidebar"
          v-bind:class="{ hoverbox: sideHover, sidebox: !sideHover, revealed: sideDisplay, biggerSideBar: subHeadTitle[sideContent]?.bigger == true, expandedbox: settings.expandedbox && sideContent == 'keyword-report' }">
          <div class="sidebar-grid-container">
            <div class="sidebar-head">
              <div style="display:flex; justify-content:center;align-items:center">
                <h3 style="font-family:summit;font-weight:bold;color:black;"><span
                    v-if="sideContent == 'keyword-report'">"{{ $store.state.displayKeyword.keywordOfNote.keyword ??
                      "none" }}"</span>{{ subHeadTitle[sideContent]?.title ?? 'Options' }}</h3>
              </div>
              <span v-on:click="$store.commit('toggleSide')" class="close-icon" style="cursor:pointer"><i
                  class="fa fa-times" aria-hidden="true"></i></span>
              <span v-if="sideContent == 'keyword-report'" v-on:click="$store.commit('toggleExpand')"
                class="expand-icon" style="cursor:pointer"><i class="fa fa-arrows-alt-h" aria-hidden="true"></i></span>
              <button v-if="sideContent == 'keyword-report'" onclick="KeywordNav('next')"
                class="btn btn-outline-primary next-icon"
                style="cursor:pointer;font-size:10px;padding:0.2rem;0.5rem;">next keyword</button>
            </div>
            <div v-if="sideContent == 'keyword-report'"
              style="text-align:center;position:absolute;left:0px;right:32px;top:0px;background-color: rgb(255 255 255 / 95%);padding:2px;z-index:1;font-size: 16px;font-weight: 700;color: #d5a97d;">
              <button onclick="KeywordNav('next')" class="btn btn-outline-primary next-icon"
                style="cursor:pointer;font-size:10px;padding:0.2rem;0.5rem;">next
                keyword</button>{{ $store.state.displayKeyword.keywordOfNote.keyword }}
              <span v-on:click="$store.commit('toggleSide')" class="close-icon" style="cursor:pointer"><i
                  class="fa fa-times" aria-hidden="true"></i></span>
            </div>
            <div class="sidebar-body">
              <div style="height:100%;width:100%;align-items:center;display:flex;flex-direction:column">
                <KeepAlive include="keyword-report">
                  <component v-bind:is="sideContent"></component>
                </KeepAlive>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



    <!--<div id="page-navigation" class="wide d-flex newTabWrapper">
            <div class="tokenCostBox d-flex flex-column" style="margin-top: 0px; margin-right:0px">
                <div style="font-size: .7rem;text-align:center">Results</div>
                <div style="font-size: .7rem;text-align:center">{{filterCount}}</div>
            </div>
            <div class="sub-nav-icon btn-effects" style="padding-left:10px;padding-right:7px;" v-on:click="$store.commit('newPage')"><i class="fas fa-plus fa-lg"></i></div>
            <div class="sub-nav-icon dropup btn-effects" style="border-right:1px solid brown;">
              <span class="dropbtntog" style="padding-right:10px;padding-left:7px;" onclick="ToggleDropdown(event)" data-toggle="dropdown" ><i class="fas fa-list fa-lg" style="margin-top:1px"></i></span>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="padding-bottom:0px;">
                  <div class="uk-flex uk-flex-column">
                      <div v-for="(page, index) in $store.state.pages" :key=index v-bind:value="index" v-on:click="$store.commit('changePage', index)" class="pop-nav-list btn-effects" style="padding-left:0px">
                          <span class="d-flex">
                              <span class="squareSize">
                                  <span v-bind:class="{located:page.active}" class="marker">
                                      <i class="fas fa-map-marker-alt"></i>
                                  </span>
                              </span>
                              <span class="pop-nav-text">{{page.title}}</span>
                          </span>
                      </div>
                      <button v-for="(tab, index) in $store.state.pages" v-bind:value="index" v-on:click="$store.commit('changePage', index)" class="uk-button uk-button-default uk-text-left" style="padding-left:0px"><span class="uk-flex"><span class="squareSize"><span v-if="tab.active" uk-icon="location"></span></span>{{tab.title}}</span></button> -->
    <!--</div>
              </div>
            </div>



            <div class="nav nav-tabs wide">
                <div v-for="(page, index) in $store.state.pages" :key="index">
                    <div else class="nav-item dropup" v-bind:class="{active:page.active, loadingPages:!finishedLoadingPages}" v-on:click="$store.commit('changePage', index)">
                        <div style="margin-right:4px;">{{page.title}}</div>
                        <span v-if="page.active" style="margin-left:7px" class="dropbtntog" data-toggle="dropdown" onclick="ToggleDropdown(event)"><i class="fas fa-chevron-up" style="margin-top:1px"></i></span>
                        <div v-if="page.active" class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="padding-bottom:0px;">
                            <div class="d-flex flex-column">
                                <input type="text" v-model="page.title" style="width:100%" v-on:change="$store.commit('RenamePage', {newtitle:page.title, tabToRename:index})">
                                <button v-if="page.code != 'keywords'" v-on:click="$store.commit('DuplicatePages', index)">Duplicate</button>
                                <button disabled>Change Color</button>
                                <button v-if="page.code != 'keywords'" v-on:click="confirm.message = 'Are you sure you want to delete this page?';confirm.funct=DeletePageWrap;confirm.params = index; PopConfirmUp();">Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="align-self: flex-end; display:flex; justify-content:center;height:100%;box-sizing:border-box">
                <div id="pageControls" style="display:flex; align-items:center"></div>
            </div>
        </div>-->

    <!--modals-->
    <div id="loginModal" class="modal fade" onclick="CloseThisModal(event)">
      <!-- Modal content -->
      <div class="modal-content center">
        <span class="close" onclick="CloseModal('loginModal')">&times;</span>
        <h3 style="color:red">You need to Login</h3>
        <p>You need to <a href="/login">Login</a> or <a href="/register">Register</a></p>
      </div>
    </div>


    <div id="componentModal" class="modal fade" onclick="CloseThisModal(event)">
      <div class="modal-content"
        :class="{ biggerModal: subHeadTitle[modalContent]?.bigger == true, biggestModal: subHeadTitle[modalContent]?.biggest == true }"
        style="">
        <span class="close" onclick="CloseModal('componentModal')">&times;</span>
        <div class="modal-header" style="text-align:center">
          <h4 class="modal-title">{{ subHeadTitle[modalContent]?.title || 'Menu' }}</h4>
        </div>
        <div class="modal-body" style="overflow:auto; max-height:80vh">
          <KeepAlive include="sheet-keywords">
            <component v-bind:is="modalContent"></component>
          </KeepAlive>
        </div>
      </div>
    </div>

    <div id="teleportcomponentModal" class="modal fade" onclick="CloseThisModal(event)">
      <div class="modal-content biggerModal" style="">
        <span class="close" onclick="CloseModal('teleportcomponentModal')">&times;</span>
        <div class="modal-header" style="text-align:center">
        </div>
        <div class="modal-body" style="overflow:auto; max-height:80vh; width:1600px">
          <div id="teleporttarget"></div>
        </div>
      </div>
    </div>


    <div id="QuickActionModal" class="modal fade" onclick="CloseThisModal(event)">
      <div class="modal-content biggerModal" style="">
        <span class="close" onclick="CloseModal('QuickActionModal')">&times;</span>
        <div class="modal-header" style="text-align:center">
          <h4 class="modal-title">Quick Action</h4>
        </div>
        <div class="modal-body" style="max-height:80vh">
          <quick-dash></quick-dash>
        </div>
      </div>
    </div>

    <div id="confirmModal" class="modal fade" onclick="CloseThisModal(event)">
      <div class="modal-content">
        <span class="close" onclick="CloseModal('confirmModal')">&times;</span>
        <div class="modal-header" style="text-align:center">
          <h4 class="modal-title">{{ confirm.title }}</h4>
        </div>
        <div class="modal-body column">
          <p>{{ confirm.message }}</p>
          <div class="d-flex">
            <button class="nicer-button" style="background-color:red;margin-right:20px"
              v-on:click="ConfirmAction()">Confirm</button><button class="nicer-button"
              onclick="CloseModal('confirmModal')" style="background-color:white">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div id="SubPlanUsedCash" class="modal" onclick="CloseThisModal(event)" style="z-index:100">
      <div class="modal-content center">
        <span class="close" onclick="CloseModal('SubPlanUsedCash')">&times;</span>
        <div class="uk-modal-header uk-flex uk-flex-center" style="text-align: center;">
          <div id="Subscription_Usage_Info_Coster"></div>
        </div>
      </div>
    </div>


    <div class="modal purchaseReplacement" onclick="CloseThisModal(event)">

      <div id="addToPurch" class="purchaseCard">


        <div id="Subscription_Usage_Info"></div>
        <div id="changeLangOption" style="display: none; color:orange; cursor:pointer"
          onclick="CloseModal('stripeModel');OpenModal('ChangeLang')">click here to change Language</div>

        <div style="display:flex;align-items:center;justify-content:center;margin-top:15px;margin-bottom:15px">
          <div class="tokenCostBox d-flex flex-column" style="margin-top: 0px; margin-right:0px">
            <div style="font-size: .7rem;text-align:center">Number Of Keywords</div>
            <div style="font-size: .7rem;text-align:center">{{ rowCount }}</div>
          </div>
        </div>

        <h3 style="text-align:center">Report</h3>
        <report-item v-if="cart" :item="cart" class="purchaseCard"></report-item>
      </div>
    </div>

    <div id="ChangeLang" class="modal fade" onclick="CloseThisModal(event)">
      <div class="modal-content">
        <span class="close" onclick="CloseModal('ChangeLang')">&times;</span>
        <select name="location" id="newLoc" v-model="locChoice">
          <option v-for="name in languageDict" :key="name.country" :value="name.country">{{ name.country }}</option>
        </select>
        <select v-if="locChoice != ''" name="lang" id="newLang" v-model="langChoice">
          <option v-for="name in languageDict[locChoice].languages" :key="name" :value="name">{{ name }}</option>
        </select>
        <button class="btn btn-info" v-on:click="SetLang()">Submit</button>
      </div>
    </div>
  </div>
</template>


<script>
import { computed } from 'vue';
import { vue3Debounce } from 'vue-debounce'

export default {
  name: "App",
  // store,
  data() {
    return {
      minutes: 0,
      auth: false,
      headingList: favInfo,
      dataNames: window.dataNames,
      locChoice: "",
      langChoice: "",
      loadingData: true,
      orderDone: true,
      templateLoading: false,
      domainCount: 0,
      urlCount: 0,
      //shows loader if it doesn't equal false
      loader: false,
      currentDropComponent: "column-sorter",
      sideBarMode: false,
      languageDict: {},
      used_location: "",
      used_language: "",
      urlArray: false,
      domainArray: false,
      //todo put in the ability to make this optional, not sure why it isn't
      subHeadTitle: {
        //component:{title:"", sideGroup:""},
        "keyword-report": { title: "", sideGroup: "Stats", bigger: true },
        "url-report": { title: "", sideGroup: "Stats", bigger: true },
        "score-column-create": {
          title: "Create Columns",
          sideGroup: "create",
          bigger: true
        },
        none: { title: "none", sideGroup: "None", bigger: false },
        "new-project": { title: "New Project", sideGroup: "None", bigger: true },
        "pivot-create": { title: "Create Pivot Table", sideGroup: "create", bigger: true },
        "pivot-create-urls": { title: "Create Urls Pivot Table", sideGroup: "create", bigger: true },
        "page-options": { title: "Add To Page", sideGroup: "None" },
        "settings-control": { title: "Settings", sideGroup: "None" },
        "sheet-keywords": { title: "Sheet Keywords", sideGroup: "None" },
        "project-viewer": { title: "Project List", sideGroup: "None", bigger: false, biggest: true },
        "cart-card": { title: "Cart", sideGroup: "None" },
        "quick-dash": { title: "Quick Actions", sideGroup: "None", bigger: true },
        "purchase-card": { title: "Confirm Purchase", sideGroup: "None" },
        "market-place": { title: "Report Market Place", sideGroup: "None", bigger: true },
      },
      sideGroup: {
        Stats: ["keyword-report"],
        None: [],
      },
      keywordGenerators: {
        "SheetKeys": { name: "Sheet Keywords", price: 0, function: "SheetKeys", code: "sheetkeyskeywordgen", description: "The standard keyword generation method. Completely Free." },
        // "BulkKeys":{name:"Bulk Add Keywords", price:400, function:"BulkKeys", code:"bulkkeyskeywordgen", description:"The best method of generating a ton of keywords quickly.", disabled:true},
        // "FindKeys":{name:"Find and Replace", price:0, function:"FindKeys", code:"substitutionkeywordgen", description:"Replace letters or numbers in your list with a specified phrase", disabled:true},
      },
      reports: {},
      reportSets: {
        popular: { name: "Popular", items: [] },
        sheeterFav: { name: "Your Favorites", items: [] },
        previousBought: { name: "Previously Bought", items: [] },
        newest: { name: "Newest", items: [] },
        trending: { name: "Trending", items: [] },
        recommended: { name: "Recommended", items: [] },
        all: { name: "All", items: [] },
        noUnder: { name: "Best", items: [] },
      },
      templates: {

        "Volume to Title ratio": {
          name: "Volume to Title ratio",
          description: "Sheet with the ratio of the search volume to title",
          necColumns: [
            "Search_Volume",
            "allintitle_Count"
          ],
          formulaColumns: [
            { type: "score", title: "TV ratio", passParam: "this.data['necColumns1'] / this.data['necColumns0']" },
            { type: "score", title: "VT ratio", passParam: "Math.round((this.data['necColumns0'] / this.data['necColumns1'] + Number.EPSILON)  * 10000000) /10000000" },
          ],
          layout: {},
          replaceColumns: true,
          items: [],
          pages: [],
        },
        // "Demo Template":{
        //   name:"Demo Template",
        //   description:"Placholder",
        //   necColumns:[],
        //   formulaColumns:[
        //     {type:"score", title:"Index * 2", passParam:"this.data.index * 2"},
        //     {type:"score", title:"Index score 1", passParam:"this.data.index % 5"},
        //     {type:"score", title:"Index score 2", passParam:"this.data.index % 6"},
        //     {type:"score",title:"Index score 3",passParam:"this.data.index % 7"},
        //     {type:"score",title:"Add score 2 and 3",passParam:"this.data['formulaFields2'] + this.data['formulaFields3']"},
        //     {type:"bucket", title:"tldr keyword", passParam:"if(this.data.keyword.length > 16){return this.data.keyword.substring(0,15) + '...'} else {return this.data.keyword}"},
        //     {type:"bucket", title:"tldr word keyword", passParam:"if(this.data.keyword.length > 16){return 'long'} else {return 'short'}"},
        //   ],
        //   layout:{},
        //   replaceColumns:true,
        //   items:[
        //     {
        //       type:'pivotTables', 
        //       groups:[{formulaId:5},{formulaId:2}], 
        //       columns:[
        //         {id:"keyword",calc:"count"},
        //         {formulaId:0, calc:"avg"},
        //         {formulaId:4, calc:"first"}
        //       ]
        //     },
        //     {
        //       type:'pivotTables', 
        //       groups:[{formulaId:1},{formulaId:2}], 
        //       columns:[
        //         {id:"keyword",calc:"count"},
        //         {formulaId:0, calc:"avg"},
        //         {formulaId:4, calc:"first"}
        //       ]
        //     },
        //     {
        //       type:'pivotTables', 
        //       groups:[{formulaId:2},{formulaId:3}], 
        //       columns:[
        //         {id:"keyword",calc:"count"},
        //         {formulaId:0, calc:"sum"},
        //         {formulaId:1, calc:"max"}
        //       ]
        //     },
        //     {
        //       type:"notes",
        //       content:"Test Template Title Test",
        //       align:"center",
        //       fontSize:"title",
        //       border:"noBorder",
        //     },
        //     {
        //       type:"notes",
        //       content:"Click me to edit me paragraph. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut elit aliquet, imperdiet lorem vitae, egestas turpis. Fusce luctus mi nec nisi luctus fermentum. Donec scelerisque tempus sem, at venenatis orci. Nunc justo dui, varius eget rutrum sit amet, consectetur id tellus. Nunc id mauris quis mauris consectetur porttitor. Donec neque elit, egestas quis facilisis vitae, fermentum et justo.",
        //       align:"left",
        //       fontSize:"medium",
        //       border:"border",
        //     },
        //     {
        //       type:"notes",
        //       content:"The next page just has more pivot tables. Click me to edit me",
        //       align:"center",
        //       fontSize:"large",
        //       border:"noBorder",
        //     },
        //   ],
        //   pages:[
        //     {
        //       title:"Introduction", 
        //       items:[3, 4, 1, 5],
        //     },
        //     {
        //       title:"Pivot Tables", 
        //       items:[0, 1, 2],
        //     },

        //   ],
        // },
      },
      HeadColumn: "start",
      HeadKeywords: "sheetkeyskeywordgen",
      HeadTemplate: "Volume to Title ratio",
      confirm: {
        funct: null,
        params: null,
        message: "Please confirm your choice.",
        title: "Please Confirm",
      },
      editTitle: false,
      headingListMade: {},
      nowcoin: coin_name ?? "Coin",
    };
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      orderDone: computed(() => this.orderDone),
    }
  },
  computed: {
    estimated_time() {
      return this.$store.state.project.estimated_time;
    },
    purchaseDate() {
      return this.$store.state.project.purchaseDate;
    },
    allReports() {
      let types = this.$store.state.project.purchaseTypes
      if (types.keyword_data == false || types.serp_results == false || types.exact_serp_results == false) return false
      return true
    },
    finishedLoadingPages() {
      return this.$store.state.finishedLoadingPages;
    },
    addKeys() {
      return this.$store.state.addKeys;
    },
    addKeyDetails() {
      return this.$store.state.addKeyDetails;
    },
    settings() {
      return this.$store.state.settings;
    },
    cart() {
      return this.$store.state.purchasing[0];
    },
    cartCount() {
      return this.$store.state.cart.length ?? 0;
    },
    usefulColumns() {
      return this.$store.getters.usefulColumns;
    },
    sideHover() {
      return this.$store.state.settings.sideboxhover;
    },
    sideDisplay() {
      return this.$store.state.sidebar.display;
    },
    sideContent() {
      return this.$store.state.sidebar.content;
    },
    activePage() {
      return this.$store.state.activePage;
    },
    pages() {
      return this.$store.state.pages;
    },
    rowCount() {
      return this.$store.state.rowCount;
    },
    filterCount() {
      return this.$store.state.filterCount;
    },

    modalContent() {
      return this.$store.state.modal.content;
    },
    shared() {
      return this.$store.state.project.shared;
    },
    sharedUrl() {
      return (
        "https://" + window.location.hostname +
        "/keyword-planner/" +
        this.$store.state.project.hash
      );
    },
    sample() {
      return this.$store.state.project.sample;
    },
    saved() {
      return this.$store.state.savingTree.saving
    },
    colFieldTitleDict() {
      return this.$store.getters.colFieldTitleDict
    },
    project() {
      return this.$store.state.project
    }
  },
  watch: {
    HeadColumn: function (val) {
      if (val == "Browse Options") {
        this.$store.commit("showModal", "market-place");
      }
    },
    HeadKeywords: function (val) {
      if (val == "Browse Options") {
        this.FullCardToggle("keywordGenCard", true);
      }
    },
    HeadTemplate: function (val) {
      if (val == "Browse Templates") {
        this.cards.templatesCard.state = "browse";
        this.FullCardToggle("templatesCard", true);
      }
    },
    locChoice: function (val) {
      this.langChoice = this.languageDict[this.locChoice].languages[0];
    },
    selectingKeywords: function (val) {
      this.UpdateCost();
    },
    selectedKeywords: function (val) {
      this.UpdateCost();
    },
    needProjects: function (val) {
      if (this.projectList == false) {
        UpdateProjectList();
      }
    },
  },
  directives: {
    debounce: vue3Debounce({ lock: true })
  },
  methods: {
    //timer status functions
    calctimediff() {
      let thejs = new Date(Date.now()).toString()
      let project = this.project
      let adjust = thejs.substring(thejs.length - 29, thejs.length - 24)
      if (project.purchaseDate != undefined && project.purchaseDate != null && project.purchaseDate != "" && project.estimated_time != undefined && project.estimated_time != null && project.estimated_time != "") {
        let dateDiff = Math.floor((Date.now() - Date.parse(project.purchaseDate + adjust)) / 60000)
        dateDiff = this.estimated_time + 60 - dateDiff
        this.minutes = dateDiff
      } else {
        this.minutes = 0
      }

      this.countDownTimer()

    },
    countDownTimer() {
      if (this.minutes > 0) {
        setTimeout(() => {
          this.minutes -= 1
          this.countDownTimer()
        }, 60000)
      }
    },
    //keyword ticker
    setFilter() {
      setFilter()
    },
    RemoveKeys(index) {
      store.commit('RemoveTopKeywordChart', index)
    },
    MakeheadingListMade() {
      let titleStart = this.headingList
      let dataStart = this.addKeys

      let returnItem = { titles: ['keyword'], data: [] }
      titleStart.forEach(function (ele) {
        if (ele.source == 'main') returnItem.titles.push(this.$store.getters.colFieldTitleDict[ele.column])
        if (dataNames[ele.column] != undefined) returnItem.titles.push(ele.column)
        if (ele.source != 'main' && dataNames[ele.column] == undefined) returnItem.titles.push(ele.column)
      }, this)
      dataStart.forEach(function (item) {
        let line = [item]
        let mainInfo = tableData.find(function (ele) {
          if (ele.keyword = item) return true
          return false
        })
        //TODO mainStats


        function findTheItem(item, column) {
          return keyword_data_cache[column.source][item].find(function (data_cache) {
            if (data_cache[column.column] != undefined) return true
            return false
          })
        }

        titleStart.forEach(function (column) {
          if (column.source == 'main' && mainInfo[column.column] != undefined) line.push(mainInfo[column.column])
          // let mainStats = findTheItem(item, column)
          // if (mainStats !== false){
          //   if(dataNames[column.column] != undefined && mainStats[column.source] !== false && column.source != 'keyword_data') mainStats[column.column][0]
          //   if(dataNames[column.column] != undefined && mainStats[column.source] !== false && column.source == 'keyword_data') mainStats[column.column]
          // }
        }, this)

        returnItem.data.push(line)
      })

      return returnItem;
      /* titleStart.forEach
      { titles:[
          'keyword',
          'blahblah'
        ],
        data:[
          {},
          {},
        ],
      } 

      <table  v-if="headList.length > 0" class="steelBlueCols favTable">
        <tbody>
          <tr v-for="column in headList" :key="column"  @dblclick="ToggleFav(column.column, column.source, true)" style="cursor:pointer">
            <td v-if="column.source == 'main'">
              {{colFieldTitleDict[column.column]}}
            </td>
            <td v-if="dataNames[column.column] != undefined">
              {{column.column}}
            </td>
            <td  v-if="column.source == 'main' && keywordInfo.keywordOfNote[column.column] != undefined">
              {{keywordInfo.keywordOfNote[column.column]}}
            </td>
            <td  v-if="dataNames[column.column] != undefined && keywordInfo.stats[column.source] !== false && column.source != 'keyword_data'">
              {{ keywordInfo.stats[column.source].new_data[column.column][0] }}
            </td>
            <td  v-if="dataNames[column.column] != undefined && keywordInfo.stats[column.source] !== false && column.source == 'keyword_data'">
              {{ keywordInfo.stats[column.source].new_data[column.column] }}
            </td>
          </tr>
        </tbody>
      </table> */

    },
    //project
    SetLang() {
      this.used_location = this.locChoice,
        this.used_language = this.langChoice,
        used_location = this.locChoice,
        used_language = this.langChoice,
        CloseAllModals();
      buyCart();
    },
    parserer(str, data) {
      console.log("gethere");
      return Function(`'use strict'; return (${str})`).call({ data: data });
    },
    parsererbucket(str, data) {
      return Function(`'use strict'; ${str}`).call({ data: data });
    },
    ShareReport() {
      //this.share.status = !this.share.status;
      //markpoint
      var shareStat = this.share.status;
      alert("/project/share cooler")
      // $.ajax({
      //   type: "POST", // Type of response and matches what we said in the route
      //   url: "/project/share/" + app.projectHash, // This is the url we gave in the route
      //   contentType: "application/json",
      //   headers: {
      //     "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      //   },
      //   dataType: "json",
      //   error: function (errorrep) {
      //     console.log(errorrep);
      //     AlertBox(
      //       "danger",
      //       "An error has occurred while sharing your project. Please reload and try again.",
      //       -1
      //     );
      //   },
      //   success: function (loadData) {
      //     // What to do if we succeed
      //     console.log(loadData);
      //     if (loadData.projectID == app.projectHash) {
      //       app.share.status = loadData.share;
      //     }
      //   },
      // });
    },

    //head functions and templates
    SetPurchase(where = "HeadColumn") {
      // disable for now
      AlertBox("danger", "Purchasing is disabled for now.");
      return;

      console.log(where);
      switch (where) {
        case 'HeadColumn':
          if (this.HeadColumn == 'start') {
            console.log("1");
            this.$store.commit("showModal", "market-place");
            break;
          }
          console.log("2");
          this.$store.commit("SetPurchasing", [this.HeadColumn]);
          break;
        case 'BuyAll':
          console.log("3");
          return;
          // this.$store.commit("SetPurchasing", [reports["everything-report"]]);
          break;
        default:
          console.log("4");
          this.$store.commit("SetPurchasing", where);
      }
    },
    openCart() {
      this.$store.commit("showModal", "cart-card");
    },
    BuildTemplateFromCurrent() {
      //Step 1: roll through columns
      var columnsUsed = this.usefulColumns.filter(function (column) {
        if (
          column.field != 'keyword' &&
          column.field != 'index' &&
          column.field != undefined
        ) return true
        return false
      })
      console.log(columnsUsed);

      //1.1 premium columns
      var necColumns = [];
      var necColFilter = {};
      var necColumnsDict = {};
      Object.keys(reportFieldsDict).forEach(function (ele) {
        columnsUsed.forEach(function (item) {
          if (item.field.includes(ele)) {
            if (necColFilter[ele] == undefined) {
              necColFilter[ele] = necColumns.length;
              necColumns.push(ele);
            }
            necColumnsDict[item.field] = necColFilter[ele];
          }
        })
      })
      console.log(necColumns);
      console.log(necColumnsDict);
      //1.2 formula columns
      var formulaCols = [];
      columnsUsed.forEach(function (item) {
        if (item.field.includes("custom")) {
          var type = "score";
          if (item.field.includes("bucket")) type = "bucket";
          if (item.field.includes("aggScore")) type = "aggScore";
          if (item.field.includes("subReport")) type = "subReport";
          formulaCols.push({ type: type, title: item.title, passParam: item.mutaParams });
        }
      })
      console.log(formulaCols);

      //1.3 visable columns

      //1.4 make formula and premium substitution in the data

      //store them with formulas reversed
      //Step 2: roll through pages
      //1.1 get needed items
      //step 3: roll trough items
      //reversing groups and pivot tables

    },
    AddTemplate(templateName, param = false) {
      if (this.HeadTemplate == "Browse Templates" && param == true) {
        return;
      }
      this.loader = "template";
      this.templateLoading = true;
      setTimeout(function () {
        app.AddTemplateWork(templateName, param);
      }, 500);
    },
    AddTemplateWork(templateName, param) {
      var template = this.templates[templateName];
      var columns = table.getColumnDefinitions();
      var startingPage = this.$store.state.pages.length;

      //step 1: Check for neccesary columns
      var templateColumnDict = {};
      var templateColumns = [];
      var failedColumns = [];

      if (template.necColumns != undefined && template.necColumns.length > 0) {
        template.necColumns.forEach(function (element) {
          var location = columns.findIndex(function (ele) {
            if (ele.type == element) return true;
            if (ele.field != undefined && ele.field.includes(element) == true)
              return true;
            return false;
          }, this);
          if (location < 0) {
            failedColumns.push(element)
          } else {
            templateColumnDict[columns[location].field] = element;
            templateColumns.push(columns[location].field);
          }
        });

        //let them know they are missing columns
        if (failedColumns.length > 0) {
          AlertBox(
            "danger",
            "Missing columns for Template: " + failedColumns.join(", ")
          );
          this.loader = false;
          this.templateLoading = false;

          //pop out purchase for first failer      
          // if (failedColumns.length > 3) this.SetPurchase('BuyAll')
          // if (failedColumns.length <= 3) this.SetPurchase([reports[TryToFindColumnInReports(failedColumns[0])]]);
          return;
        }
      }
      console.log(templateColumns);

      //Step 2: Hide columns that aren't being used
      if (template.replaceColumns === true) {
        table.getColumns().forEach(function (element) {
          if (
            element._column.field == "keyword" ||
            element._column.definition.dontHide == true ||
            templateColumnDict[element._column.field] != undefined
          ) {

          } else if (element._column.field != undefined) {
            element.hide();
            element._column.definition.visible = false;
          } else if (element._column.headerSort != false) {
            element.hide();
            element._column.definition.visible = false;
          }
        });
      }

      //register necColumns in formulas this means formulas need to 

      //Step 3: Create necessary columns, and make used columns visible
      var formulaFields = [];
      if (
        template.formulaColumns != undefined &&
        template.formulaColumns.length > 0
      ) {
        template.formulaColumns.forEach(function (element, index) {
          //checkpoint check if they already have the column before trying to make it. if so, make it visible.
          var foundColumn = false;
          table.getColumns().forEach(function (item) {
            if (item._column.definition.title == element.title) {
              foundColumn = item;
            }
          }, this);
          if (foundColumn != false) {
            foundColumn.show();
            foundColumn._column.definition.visible = true;
            formulaFields.push(foundColumn.getField());
          } else {
            console.log("template column");
            let newCol = newColumnBackup(element, templateColumns, formulaFields);
            formulaFields.push(newCol);
          }
        }, this);
        if (formulaFields.length > 1) table.getColumn(formulaFields[0]).setWidth(200);
      }

      //TODO Step 3.5: column layouts

      //Step 4: add items
      var itemArray = [];
      template.items.forEach(function (element) {
        if (element.type == "pivotTables") {
          var pivot = {};

          var groups = element.groups.map(function (group) {
            if (group.formulaId == undefined)
              return table.getColumn(group).getDefinition();
            return table
              .getColumn(formulaFields[group.formulaId])
              .getDefinition();
          });

          var columns = element.columns.map(function (column) {
            if (column.formulaId == undefined)
              return table.getColumn(column.id).getDefinition();
            return table
              .getColumn(formulaFields[column.formulaId])
              .getDefinition();
          });

          var calcArray = element.columns.map((ele) => ele.calc);

          var pivotNew = {
            data: tableData,
            groups: groups,
            columns: columns,
            calcArray: calcArray,
          };
          this.$store.commit("generatePivotTable", pivotNew);
          itemArray.push(
            this.$store.state.pivotTables[
            this.$store.state.pivotTables.length - 1
            ]
          );
        }

        if (element.type == "notes") {
          this.$store.commit("GenerateNote", element);
          itemArray.push(
            this.$store.state.notes[this.$store.state.notes.length - 1]
          );
        }
      }, this);

      //Step 5: add pages
      if (template.pages != undefined && template.pages.length > 0) {
        let startingPage = this.$store.state.pages.length;

        template.pages.forEach(function (element) {
          let tempItems = element.items.map((ele) => itemArray[ele]);
          this.$store.commit("newPage", {
            noFollow: true,
            title: element.title,
            code: "template-gen",
            items: tempItems,
          });
        }, this);
        this.$store.commit("changePage", startingPage);
      }
      this.loader = false;
      this.templateLoading = false;
    },

    AddTempl(templateName, param) {
      if (ourTemplate.overtabs != undefined) {
        let overtabsToOpen = this.overtabs.length;
        ourTemplate.overtabs.forEach(function (element) {
          var itemsFor = [];
          element.items.forEach(function (item) {
            //add each element
            if (item.type == "pivotTables") {
              var tableId;
              if (this.pivotTables.length == 0) {
                tableId = 1;
              } else {
                tableId = this.pivotTables[this.pivotTables.length - 1].id + 1;
              }
              var pivgroups = item.groups.map(function (group) {
                if (group.formulaId == undefined) {
                  return group;
                } else {
                  return formulaColumnDict[group.formulaId];
                }
              });
              var pivcolumns = item.groups.map(function (group) {
                var starterCol;
                if (group.formulaId == undefined) {
                  starterCol = table.getColumn(group).getDefinition();
                } else {
                  starterCol = table
                    .getColumn(formulaColumnDict[group.formulaId])
                    .getDefinition();
                }
                return {
                  field: starterCol.field,
                  title: starterCol.title,
                  visible: true,
                  formatter: "pivotGroupFormat",
                };
              });

              item.columns.forEach(function (column, index) {
                var starterCol;
                if (column.formulaId == undefined) {
                  starterCol = table.getColumn(column.id).getDefinition();
                } else {
                  starterCol = table
                    .getColumn(formulaColumnDict[column.formulaId])
                    .getDefinition();
                }
                pivcolumns.push({
                  field: starterCol.field + " " + index,
                  title: column.calc + " of " + starterCol.title,
                  visible: true,
                  mutator: "customListMutator",
                  mutatorParams: {
                    type: column.calc,
                    field: starterCol.field,
                    dataField: "rows",
                  },
                });
              });
              var newPivot = {
                type: "pivotTables",
                id: tableId,
                info: {
                  groups: pivgroups,
                  columns: pivcolumns,
                  source: "table",
                  data: PivotGroupBy(tableData, pivgroups),
                  title: "Pivot Table " + tableId,
                },
              };
              this.pivotTables.push(newPivot);
              this.savingTree.pivot_table.new.push(newPivot);
              this.savingTree.saving = true;
              itemsFor.push(this.pivotTables[tableId - 1]);
            }
          }, this);
          this.overtabs.push({
            title: element.title,
            active: false,
            code: "template-gen",
            items: itemsFor,
          });
        }, this);
        this.ChangeOverTab(overtabsToOpen);
      }

      this.ChangeOverTab("last");
      this.$store.commit("updateColumns");
      this.loader = false;
      this.templateLoading = false;
    },

    //cart
    updateCost() { },
    SetCartStepInterStep(args) {
      this.SetCartStep(args[0], args[1], args[2]);
    },
    SetCartStep(step, target, purchasing, justReport = false) {
      this.FullCardToggle("cartCard", true);
      this.cards.cartCard.currentStep = step;

      if (step == "confirmPrice") {
        if (purchasing == "all") {
          purchasing = this.reports.noUnder.items.map(function (element) {
            var returnItem = { report: element, options: {} };
            if (element.options.language) {
              returnItem.options.language = {
                country: this.defaultCountry,
                language: this.defaultLanguage,
              };
            }
            return returnItem;
          }, this);
        }
        if (justReport) {
          if (purchasing == "Browse Options") {
            this.FullCardToggle("reportsCard", true);
            return;
          }
          purchasing = [{ report: purchasing, options: {} }];
          if (purchasing[0].report.options.language == true) {
            purchasing[0].options.language = {
              country: this.defaultCountry,
              language: this.defaultLanguage,
            };
          }
        }
        console.log(purchasing);

        this.cards.cartCard.confirmPrice.reTarget = target;
        this.cards.cartCard.confirmPrice.rePurchase = purchasing;

        this.cards.cartCard.breadcrumbs = ["Cart", "Purchase"];

        this.pendingPurchase = purchasing;
        this.cards.cartCard.confirmPrice.state = "loading";
        this.cards.cartCard.confirmPrice.message = "";

        //convert to country codes
        var cartReports = ConvertToReportCode(purchasing);
        var cartData = [];
        var cartItems = [];
        if (target == "selected") {
          cartItems = table.getSelectedData();
          if (cartItems.length < 1) {
            cartItems = tableData;
            this.cards.cartCard.confirmPrice.message =
              "You did not have any data selected. This price is for the whole table.";
          }
        } else if (target == "all") {
          cartItems = tableData;
        } else {
          cartItems = target;
        }

        purchaseDate = new Date();
        let timeStamp = purchaseDate;

        //markpoint
        cartItems.forEach(function (item) {
          cartData.push({
            cart_item: item.keyword,
            index: item.index,
            products: cartReports,
          });
        });
        alert("/get_cost cooler")
        //set up cart for buying
        // $.ajax({
        //   method: "POST", // Type of response and matches what we said in the route
        //   contentType: "application/json",
        //   url: "/get_cost", // This is the url we gave in the route
        //   dataType: "json",
        //   data: JSON.stringify([projectHash, cartData, "queue_keywords"]),
        //   success: function (cost) {
        //     console.log(cost);
        //     if (timeStamp == purchaseDate) {
        //       if (cost.error != undefined) {
        //         app.cards.cartCard.confirmPrice.state = "fail";
        //         app.cards.cartCard.confirmPrice.message =
        //           "You already have all those reports for the keywords selected.";
        //       }
        //       if (cost.enough_funds == false) {
        //         AlertBox(
        //           "danger",
        //           "You do not have enough {{ nowcoin }}s. Please buy some and try again."
        //         );

        //         app.cards.cartCard.confirmPrice.state = "not_enough_funds";
        //         coinsShort = cost.neededFunds;

        //         nSheetcoins = Math.ceil(cost.cost * 1.2);
        //         app.cards.cartCard.confirmPrice.message =
        //           "You have " +
        //           sheetCoinCount +
        //           " {{ nowcoin }}s. \nYou need " +
        //           cost.price +
        //           " {{ nowcoin }}s. \nYou could purchase mo{{ nowcoin }}oins, or pay " +
        //           Math.ceil(cost.cost * 1.2) / 100 +
        //           " USD.";
        //         //{centAmount:Math.ceil(cost.cost * 1.2)});
        //       } else if (cost.cost > 0) {
        //         app.cards.cartCard.confirmPrice.timer = new Date();
        //         app.cards.cartCard.confirmPrice.state = "enough_funds";
        //         app.cards.cartCard.confirmPrice.message =
        //           "Spend " + cost.cost + " {{ nowcoin }}s?";
        //       } else {
        //         AlertBox("danger", "Nothing Selected to Purchase");
        //         app.cards.cartCard.confirmPrice.state = "fail";
        //         app.cards.cartCard.confirmPrice.message =
        //           "Nothing Selected For Purchase.";
        //       }
        //     }
        //   },
        // });
      } else if (step == "complete") {
        if (target == "waiting") {
          app.cards.cartCard.complete.message =
            "Completing your purchase now, please hold for a few moments";
        } else if (target == "done") {
          app.cards.cartCard.complete.message =
            "You Purchase has been completed! Your data should be start shortly.";
          app.cards.purchasehistory.push(pendingPurchase);
          app.cards.purchasehistory.cardState = true;
          app.cards.cartCard.reports = [];
        }
      }
    },

    PurchaseNow(report) {
      console.log(report, "buy");
    },
    UpdateCost() {
      if (this.cards.cartCard.reports.length > 0 && this.selectedKeywords > 0) {
        var amount = this.selectedKeywords;
        var costArray = this.cards.cartCard.reports.map(function (element) {
          return Math.ceil(
            Math.max(element.report.min, element.report.price * amount)
          );
        });
        console.log(costArray);
        this.totalCost = costArray.reduce(AddCost);
      } else {
        this.totalCost = 0;
      }
    },
    ContinuePurchase(params) {
      console.log("sweep");
      ContinuePurchase(params);
    },
    AddToCartInterStep(args) {
      this.AddToCart(args[0], args[1]);
    },
    AddToCartjj(report, additionalOptions = false) {
      console.log(report, "cart");
      var tempReport = { report: report, options: additionalOptions };

      tempCarts = ConvertToReportCode(this.cards.cartCard.reports);
      tempCode = ConvertToReportCode([tempReport]);
      var foundMatch = tempCarts.some(function (element) {
        if (element == tempReport[0]) {
          return true;
        } else {
          return false;
        }
      });
      if (!foundMatch) {
        this.cards.cartCard.reports.push(tempReport);
        UIkit.notification({
          status: "success",
          message: "Report added to cart.",
        });

        this.UpdateCost();
      } else {
        UIkit.notification({
          status: "danger",
          message: "That report is already in your cart.",
        });
      }

      this.cards.cartCard.cardState = true;
    },
    RemoveFromCart(index) {
      this.cards.cartCard.reports.splice(index, 1);

      this.UpdateCost();
    },

    //groups

    //misc
    PopConfirmUp() {
      OpenModal("confirmModal");
    },
    ConfirmAction() {
      CloseModal("confirmModal");
      this.confirm.funct(this.confirm.params);
    },
    DeletePageWrap(info) {
      this.$store.commit("DeletePage", info);
    },
    Resizer(e) {
      console.log(e)

      let prevX = e.x;
      let alreadyAdjust = 0

      function mousemove(e) {

        let newX = prevX - e.x;
        let prevSize = getComputedStyle(document.documentElement, null).getPropertyValue("--sidebar-width");
        //setting a minimum and maximum siz for the drag
        let sizemax = (document.getElementById('page-container').offsetWidth - 500) > 0 ? (document.getElementById('page-container').offsetWidth - 500) : document.getElementById('page-container').offsetWidth
        let newSize = (Math.min(Math.max((parseInt(prevSize.substring(0, prevSize.length - 2)) + (newX - alreadyAdjust)), 350), sizemax)) + 'px'
        document.documentElement.style.setProperty("--sidebar-width", newSize);
        alreadyAdjust = newX
      }

      function mouseup() {
        window.removeEventListener('mousemove', mousemove);
        window.removeEventListener('mouseup', mouseup);
      }

      window.addEventListener('mousemove', mousemove);
      window.addEventListener('mouseup', mouseup);
    },

    //outdated
    groupstatchange(params) {
      if (params.how == "add") {
        this.cards.metaCard.groups[params.groupNumber].statistics.push({
          type: params.type,
          field: params.field,
        });
        this.savingTree.groups.update.push({
          id: params.groupNumber,
          change: "statistics",
          statistics: this.cards.metaCard.groups[params.groupNumber].statistics,
        });
        this.savingTree.saving = true;
      } else if (params.how == "remove") {
        console.log(params.groupNumber);
        console.log(this.cards.metaCard.groups);
        this.cards.metaCard.groups
          .find((element) => element.id == params.groupNumber)
          .statistics.splice(params.whichStat, 1);
        this.savingTree.groups.update.push({
          id: params.groupNumber,
          change: "statistics",
          statistics: this.cards.metaCard.groups[params.groupNumber].statistics,
        });
        this.savingTree.saving = true;
      } else {
        console.log("opps");
      }
    },

    GroupSelectedRows() {
      var selectedRows = table.getSelectedRows();
      if (selectedRows.length > 0) {
        var selectedData = table.getSelectedData();
        var newGroup = {
          type: "groups",
          id: this.cards.metaCard.groups.length,
          title: selectedData[0].keyword + " group",
          data: selectedData,
          rowAmount: selectedData.length,
          statistics: [],
        };
        this.cards.metaCard.groups.push(newGroup);
        this.savingTree.groups.new.push(newGroup);
        this.savingTree.saving = true;
        console.log(this.savingTree.groups.new);

        UIkit.notification({
          status: "success",
          message:
            "Group Created <button onclick=\"store.commit('groupPage')\">Create tab with group</button>",
          timeout: 100000,
        });
      } else {
        UIkit.notification({
          status: "danger",
          message: "no keywords selected",
        });
      }
    },
    ChangeOverTab(tabToOpen) {
      if (tabToOpen == "last") {
        tabToOpen = this.overtabs.length - 1;
      }
      this.overtabs.forEach(function (element, index) {
        if (index != tabToOpen) {
          this.overtabs[index].active = false;
        } else {
          this.activePage = this.overtabs[tabToOpen];
          this.overtabs[tabToOpen].active = true;
        }
      }, this);
    },
    DuplicateOvertab(tabToCopy) {
      var copytab = this.overtabs[tabToCopy];
      var newItems = Object.assign({}, copytab.items);
      this.overtabs.push({
        title: "duplicate " + copytab.title,
        active: false,
        code: copytab.code,
        items: newItems,
      });
    },
    DeleteOvertab(tabToDelete) {
      this.overtabs.splice(tabToDelete, 1);
    },
    AddToactivePage(what, newItem) {
      console.log(what, newItem);
      if (what == "pivotTables") {
        if (newItem === true) {
          var tableId;
          if (this.pivotTables.length == 0) {
            tableId = 1;
          } else {
            tableId = this.pivotTables[this.pivotTables.length - 1].id + 1;
          }
          //add table info to variable
          var newPivot = {
            type: "pivotTables",
            id: tableId,
            startOpen: true,
            info: {
              groups: [],
              columns: [],
              source: "table",
              data: PivotGroupBy(tableData, []),
              title: "Pivot Table " + tableId,
            },
          };
          this.pivotTables.push(newPivot);
          this.savingTree.pivot_table.new.push(newPivot);
          this.savingTree.saving = true;
          this.activePage.items.push(
            this.pivotTables[this.pivotTables.length - 1]
          );
          console.log(this.pivotTables);
        } else {
          this.activePage.items.push(this.pivotTables[newItem]);
        }
      } else if (what == "groups") {
        if (newItem === true) {
          console.log("how?");
        } else {
          console.log(this.cards.metaCard.groups[newItem]);
          this.activePage.items.push(this.cards.metaCard.groups[newItem]);
        }
      }
    },
    CreateStockOvertab(tabType) {
      if (tabType == "sheeting") {
      } else if (tabType == "notes") {
        this.overtabs.push({
          title: "Notes",
          active: false,
          code: "notes-gen",
          items: [{ type: "notes", text: "" }],
        });
        this.ChangeOverTab("last");
      } else if (tabType == "Data History") {
      } else if (tabType == "Groups panel") {
        this.overtabs.push({
          title: "Keyword Groups",
          active: false,
          code: "groups-gen",
          items: [],
        });
        this.ChangeOverTab("last");
      } else if (tabType == "chart") {
      } else if (tabType == "Pivot Table") {
        this.overtabs.push({
          title: "Pivot Tables",
          active: false,
          code: "pivots-gen",
          items: [],
        });
        this.ChangeOverTab("last");
      }
    },
    RenameOvertab(newtitle, tabToRename) {
      this.overtabs[tabToRename].title = newtitle;
    },
    addkeywordgrouppivottable(groId) {
      var tableId;
      if (this.pivotTables.length == 0) {
        tableId = 1;
      } else {
        tableId = this.pivotTables[this.pivotTables.length - 1].id + 1;
      }
      var newPivot = {
        type: "pivotTables",
        id: tableId,
        startOpen: true,
        info: {
          groups: [],
          columns: [],
          source: groId,
          data: PivotGroupBy(
            this.cards.metaCard.groups.find((ele) => ele.id == groId).data,
            []
          ),
          title: "Pivot Table " + tableId,
        },
      };
      this.savingTree.pivot_table.new.push(newPivot);
      this.savingTree.saving = true;
      this.pivotTables.push(newPivot);
      this.activePage.items.push(this.pivotTables[this.pivotTables.length - 1]);
    },
    grouptitlechange(infouse) {
      this.cards.metaCard.groups.forEach(function (element) {
        if (element.id == infouse.id) {
          element.title = infouse.title;
          this.savingTree.groups.update.push({
            id: infouse.id,
            change: "title",
            title: infouse.title,
          });
        }
      }, this);
    },

    //unsorted
    CoolNotification(params) {
      UIkit.notification(params);
    },
    RenameAction() {
      UIkit.modal("#renameModel").hide();
      this.rename.funct(this.rename.renameTitle, this.rename.params);
    },

    //templates

    //column functions
    Visible(columns) {
      return columns.filter(function (element) {
        return element.visible == true && element.field != "keyword";
      });
    },
    Invisible(columns) {
      return columns.filter(function (element) {
        return element.visible == false && element.field != "index";
      });
    },
    HideColumn(column) {
      table.getColumn(column.field).hide();
      this.$store.commit("updateColumns");
    },
    ShowColumn(column) {
      table.getColumn(column.field).show();
      this.$store.commit("updateColumns");
    },
    ToggleColumnVisibility(column) {
      table.getColumn(column.field).toggle();
    },
    NewColumnInnerStep(value) {
      if (value.visibility == undefined) {
        this.NewColumn(value.type, value.title, value.passParam);
      } else {
        this.NewColumn(
          value.type,
          value.title,
          value.passParam,
          value.visibility
        );
      }
    },
    //I know the order of these attributes looks wrong
    NewColumn(type = "edit", passTitle = false, passParam, visibility = true) {
      console.log(type);
      console.log(passParam);
      var columnArr = table.getColumnDefinitions();
      var newTitle;

      if (passTitle == false) {
        newTitle = this.cards.settings.states.addColumns.titleTextbox;
      } else {
        newTitle = passTitle;
      }

      var fieldEnd = columnArr.length + 1;
      var titleFound = false;
      columnArr.forEach(function (col) {
        if (col.title == newTitle) {
          titleFound = true;
        }
        /*
           if (col.field != undefined){
             if (col.field.includes("custom")) {
               fieldEnd = fieldEnd + 1;
             }
           }
           */
      });

      if (titleFound == false) {
        if (type == "edit") {
          table.addColumn({
            title: newTitle,
            visible: visibility,
            field: "custom_" + fieldEnd,
            width: "200",
            formatter: "plaintext",
            formatterParams: [],
            editor: "input",
            cellEdited: function (cell) {
              newCustom[cell._cell.row.data.index] = 1;
              runUpdates = true;
            },
          });
          //reports_dict["custom_"+fieldEnd] = {field:"custom_"+fieldEnd, title:newTitle, price:0};
          this.MoveColumnBeforeEasyCol("custom_" + fieldEnd);
          this.UpdateColumnInfo();
          return "custom_" + fieldEnd;
        } else if (type == "import") {
          table.addColumn({
            title: newTitle,
            visible: visibility,
            field: "custom_import_" + fieldEnd,
            width: "200",
            formatter: "plaintext",
            formatterParams: [],
          });
          //reports_dict["custom_import_"+fieldEnd] = {field:"custom_import_"+fieldEnd, title:newTitle, price:0};
          this.MoveColumnBeforeEasyCol("custom_import_" + fieldEnd);
          this.UpdateColumnInfo();
          return "custom_import_" + fieldEnd;
        } else if (type == "score") {
          CreateCustomColumnFunction("custom_score_" + fieldEnd, passParam);
          customScores["custom_score_" + fieldEnd] = passParam;
          //markpoint save score columns?
          table.addColumn({
            title: newTitle,
            field: "custom_score_" + fieldEnd,
            formatter: "plaintext",
            formatterParams: [],
            visible: visibility,
            mutator: "customColumnMutator",
            width: "200",
            mutatorParams: passParam,
          });
          //reports_dict["custom_score_"+fieldEnd] = {field:"custom_score_"+fieldEnd, title:newTitle, price:0};
          table.redraw(true);
          this.MoveColumnBeforeEasyCol("custom_score_" + fieldEnd);
          this.UpdateColumnInfo();
          return "custom_score_" + fieldEnd;
        } else if (type == "bucket") {
          CreateCustomColumnFunction("custom_bucket_" + fieldEnd, passParam);
          //markpoint save bucket columns
          table.addColumn({
            title: newTitle,
            field: "custom_bucket_" + fieldEnd,
            formatter: "plaintext",
            formatterParams: [],
            visible: visibility,
            mutator: "customBucketMutator",
            width: "200",
            mutatorParams: passParam,
          });
          //reports_dict["custom_bucket_"+fieldEnd] = {field:"custom_bucket_"+fieldEnd, title:newTitle, price:0};
          this.MoveColumnBeforeEasyCol("custom_bucket_" + fieldEnd);
          this.UpdateColumnInfo();
          return "custom_bucket_" + fieldEnd;
        } else if (type == "aggScore") {
          CreateCustomColumnFunction("custom_aggScore_" + fieldEnd, passParam);
          //markpoint save bucket columns
          table.addColumn({
            title: newTitle,
            field: "custom_aggScore_" + fieldEnd,
            formatter: "plaintext",
            formatterParams: [],
            visible: visibility,
            mutator: "customListMutator",
            width: "200",
            mutatorParams: passParam,
          });
          //reports_dict["custom_aggScore_"+fieldEnd] = {field:"custom_aggScore_"+fieldEnd, title:newTitle, price:0};
          this.MoveColumnBeforeEasyCol("custom_aggScore_" + fieldEnd);
          this.UpdateColumnInfo();
          return "custom_aggScore_" + fieldEnd;
        } else if (type == "subReport") {
          CreateCustomColumnFunction("custom_subReport_" + fieldEnd, passParam);
          //markpoint save bucket columns
          table.addColumn({
            title: newTitle,
            field: "custom_subReport_" + fieldEnd,
            visible: false,
            list: true,
            mutator: "subReport",
          });
          //reports_dict["custom_subReport_"+fieldEnd] = {field:"custom_subReport_"+fieldEnd, title:newTitle, price:0};
          this.UpdateColumnInfo();
          return "custom_subReport_" + fieldEnd;
        }
      }
      this.$store.commit("updateColumns");
      if (passTitle == false) {
        this.cards.settings.states.addColumns.titleTextbox = "";
      }
    },
    MoveColumnBeforeEasyCol(colToMove) {
      var firstEascol = table.getColumns().find(function (element) {
        if (element.getDefinition().easyCol === true) {
          return true;
        }
        return false;
      });
      if (firstEascol != undefined) {
        table.getColumn(colToMove).move(firstEascol, false);
      }
    },
    UpdateColumnInfo() {
      this.savingTree.layout = true;
      this.savingTree.saving = true;
      this.$store.commit("updateColumns");
    },

    //display functions
    FullCardToggle(activeCard, onlyOpen = false, subStates = false) {
      this.cards[activeCard].active = !this.cards[activeCard].active;
      if (onlyOpen) {
        this.cards[activeCard].active = true;
      }
      var cardList = Object.keys(this.cards);
      cardList.forEach(function (element) {
        if (element != activeCard) {
          this.cards[element].active = false;
        }
      }, this);
      this.fullCardState.state = this.cards[activeCard].active;
      this.fullCardState.title = this.cards[activeCard].title;

      if (this.cards[activeCard]?.states !== undefined) {
      }
      if (subStates != false && this.cards[activeCard].states != undefined) {
        if (subStates == "all") {
          //activate all
          Object.keys(this.cards[activeCard].states).forEach(function (
            element
          ) {
            this.cards[activeCard].states[element].active = true;
          },
            this);
        } else {
          Object.keys(this.cards[activeCard].states).forEach(function (
            element
          ) {
            this.cards[activeCard].states[element].active = false;
          },
            this);
          if (subStates.length > 0) {
            subStates.forEach(function (element) {
              this.cards[activeCard].states[element].active = true;
            }, this);
          }
        }
        console.log(this.cards[activeCard].states);
      }
    },
    HideCardShow() {
      var cardList = Object.keys(this.cards);
      cardList.forEach(function (element) {
        this.cards[element].active = false;
      }, this);
      this.fullCardState.state = false;
    },
    SetSelectedReport(reportField) {
      this.selectedReport = this.reports.all.items.find(
        (element) => element.field == reportField
      );
      this.FullCardToggle("reportsCard", true);
      this.marketState = "report";
    },
    SetKeyword(keywordData, openReport = false) {
      this.cards.keywordCard.keywordData = keywordData;
      var propertyList = Object.keys(keywordData);
      var tempItems = [];
      var tempUnpack = [];
      var tableId = 1;
      var columndefs = table.getColumnDefinitions();
      var columnInfoDict = {};
      columndefs.forEach(function (columner) {
        if (columner.field != undefined) {
          columnInfoDict[columner.field] = columner.title;
        }
      });
      propertyList.forEach(function (element) {
        if (
          hiddenReports[element] == undefined &&
          this.unpackReports[element] == undefined
        ) {
          tempItems.push({
            item: columnInfoDict[element],
            value: keywordData[element],
          });
        } else if (this.unpackReports[element] != undefined) {
          tempUnpack.push({
            title: element,
            data: keywordData[element],
            id: tableId++,
          });
        }
      }, this);
      this.cards.keywordCard.items = tempItems;
      this.cards.keywordCard.extraReports = tempUnpack;
      if (openReport) {
        this.FullCardToggle("keywordCard", true);
      }
    },
    ShortList(list, amount = 4) {
      return list.slice(0, amount);
    },
  },
  mounted: function () {
    console.log("started");
    store.commit("changePage", 0);
    if (postScript) OnStartPostApp();
    if (!postScript) postScript = true;
  },
};
</script>

<style>
#app {}
</style>
